export const DOCS_PAGE_HEADER_TITLE = 'DMP Documentation'

export const DOCS_MANIFEST_URL = '/docs-data/manifest.json'
export const DOCS_SEARCH_INDEX_URL = '/docs-data/search.json'

export const DOCS_COPY_SUCCESS_MESSAGE = 'Copied to clipboard'
